// events/addToBasketEvent.ts

export const ADD_TO_BASKET_EVENT = 'addToBasket';

export interface AddToBasketEventDetail {
	targetElement: HTMLElement;
	productId: number;
	productName?: string;
	productType: string;
	quantity: string | number;
	isPersonalized: boolean;
	depositPrice?: string;
}

/**
 * Dispatches an add to basket event.
 *
 * @param {AddToBasketEventDetail} detail - The product details to add to the basket.
 */
export function dispatchAddToBasket(detail: AddToBasketEventDetail): void {
	document.dispatchEvent(
		new CustomEvent<AddToBasketEventDetail>(ADD_TO_BASKET_EVENT, { detail }),
	);
}
